<!--
グラフ出力画面(生産効率向け)
URL：/graph/product
-->

<template>
  <div>
    <v-container v-show="this.$parent.dispFlag.graph">
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-tabs
        v-model="tabIndex"
        centered
        color="white"
        center-active
        active-class="tab-active"
      >
        <v-tabs-slider color="transparent"></v-tabs-slider>
        <v-tab
          class="tab-item"
          style="width: 0px; padding: 0px; min-width: 0px"
        />
        <v-tab
          class="tab-item"
          style="font-size: 16pt"
          v-for="item in tabItems"
          :key="item.key"
          @click.stop="item.callback"
        >
          {{ item.label }}
          <span v-if="item.notice" class="notice">！</span>
        </v-tab>
      </v-tabs>

      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col
          cols="auto"
          style="display: flex; align-items: center; padding: 10px"
        >
          <v-card elevation="0" class="ma-4; overflow-x-auto" outlined>
            <v-card-text>
              <v-row>
                <v-col cols="auto" style="width: 470px; margin-right: 20px">
                  <GChart
                    :type="chartType"
                    :data="chartData"
                    :options="chartOptions"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        style="text-align: center; margin-top: 10px"
        v-show="dispPagenationFlag"
      >
        <v-col cols="auto" style="padding: 0px; width: 1000px">
          <month-picker-graph
            ref="month_picker_graph"
            @on-select-calendar-month="onSelectCalenderMonth"
          ></month-picker-graph>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MonthPickerGraph from "../graph-sub-contents/month-picker-graph.vue";
import { GChart } from "vue-google-charts/legacy";
import Alert from "../common/alert.vue";
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  components: {
    "month-picker-graph": MonthPickerGraph,
    GChart,
    alert: Alert,
  },
  data() {
    // 表示データ(グラフの種類)
    this.graphKindName = "";
    // 表示年1
    this.dispYear1 = "";
    // 表示年2
    this.dispYear2 = "";
    // ユーザーID
    this.uid = "";
    // API取得集計データ
    this.summary_data = [];
    // ページネーション出力フラグ
    this.dispPagenationFlag = false;
    // グラフ種別
    this.chartType = "";
    // グラフデータ
    this.chartData = [];
    // 週別向けグラフデータ保存用
    this.chartDataRsv = [];

    // グラフ表示オプション設定
    this.chartOptions = {
      // グラフ表示枠の幅(初期値)
      width: 0,
      // グラフ表示枠の高さ
      height: 0,
      // グラフ表示枠の左端からの有効位置(px)と領域使用率
      chartArea: {
        left: 85,
        width: "100%",
      },
      bar: {
        // グラフ棒各幅を100%に設定
        groupWidth: "100%",
      },
      // 凡例の表示位置(下部)の設定
      legend: {
        position: "bottom",
      },
    };

    this.$nextTick(() => {});

    return {
      // エラー情報初期化
      errors: [],
      // グラフ表示オプション設定値反映
      chartOptions: this.chartOptions,
      // 月別ボタン選択状態
      tabIndex: 1,
      // グラフデータ
      chartData: [],
    };
  },
  methods: {
    /**
     * カレンダーで選択した月に対してグラフ出力する
     */
    onSelectCalenderMonth(selectMonth) {
      this.dispGraphData(Number(selectMonth.substring(5, 7)).toString());
    },

    /**
     * 選択したページ番号に対応するグラフを出力する
     */
    dispGraphData(selectMonth) {
      var row;
      var chartDataSub = [];

      // ヘッダ情報を設定
      chartDataSub.push(this.chartDataRsv[0]);

      // 指定月毎にグラフデータ設定
      switch (selectMonth) {
        case "10":
        case "11":
        case "12":
        case "3":
        case "4":
        case "5":
        case "6":
          // 全データリストのうち当年n月分又は、翌年n月分のみ切り出す
          for (row of this.chartDataRsv) {
            if (row[0].indexOf(selectMonth + "月") != -1) {
              chartDataSub.push(row);
            }
          }
          break;
        case "1":
        case "2":
          // 全データリストのうち翌年1月分のみ切り出す
          for (row of this.chartDataRsv) {
            if (row[0].indexOf("1" + selectMonth + "月") == -1 &&
              row[0].indexOf(selectMonth + "月") != -1) {
              chartDataSub.push(row);
            }
          }
          break;
      }
      // グラフオブジェクトに表示データ設定
      this.chartData = chartDataSub;
    },
    /**
     * 月別グラフ表示用データを設定する
     */
    setDataMonth(
      graphKindName,
      dispYear1,
      dispYear2,
      uid,
      summary_data,
      dispPagenationFlag
    ) {
      this.graphKindName = graphKindName;
      this.dispYear1 = dispYear1;
      this.dispYear2 = dispYear2;
      this.uid = uid;
      this.summary_data = summary_data;
      this.dispPagenationFlag = dispPagenationFlag;

      // 月別ボタン選択状態
      this.tabIndex = 1;
      // 月別集計配列
      var monthlyTotalArr = [];

      // 出力メッセージ領域クリア
      this.clearMessage();

      // 重複チェックフラグ初期化
      this.summary_data[1] = this.resetDuplicateFlag(this.summary_data[1])

      // グラフ情報設定
      this.setChartSettings();

      switch (this.graphKindName) {
        case "総生産効率の比較":
          // グラフデータ初期化
          this.chartData = this.initChartData();

          // 集計配列を生成して水揚げ日基準で集計
          monthlyTotalArr = this.calcTotal(13, 6);

          // 月別グラフデータを生成
          this.chartData = this.genarateGraphData(this.chartData, monthlyTotalArr);
          break;

        case "生産者当たりの生産効率の比較":
          // グラフデータ初期化
          this.chartData = this.initChartData(true);

          // 集計配列を生成して水揚げ日基準で集計
          monthlyTotalArr = this.calcTotal(13, 6, true);

          // 月別グラフデータを生成
          this.chartData = this.genarateGraphData(this.chartData, monthlyTotalArr, true);
          break;

        default:
          break;
      }
    },
    /**
     * 週別グラフ表示用データを設定する
     */
    setDataWeek(
      graphKindName,
      dispYear1,
      dispYear2,
      uid,
      summary_data,
      dispPagenationFlag
    ) {
      this.graphKindName = graphKindName;
      this.dispYear1 = dispYear1;
      this.dispYear2 = dispYear2;
      this.uid = uid;
      this.summary_data = summary_data;
      this.dispPagenationFlag = dispPagenationFlag;

      // 週別ボタン選択状態
      this.tabIndex = 2;
      // 週別集計配列
      var weeklyTotalArr = [];

      // 出力メッセージ領域クリア
      this.clearMessage();

      // 重複チェックフラグ初期化
      this.summary_data[1] = this.resetDuplicateFlag(this.summary_data[1])

      // グラフ情報設定
      this.setChartSettings();

      // 表示対象種別毎にグラフ(デフォルト用)情報を設定する
      switch (this.graphKindName) {
        case "総生産効率の比較":
          // グラフデータ初期化
          this.chartDataRsv = this.initChartData();

          // 集計配列を生成して水揚げ日基準で集計
          weeklyTotalArr = this.calcTotal(61, 6);

          // 週別グラフデータを生成
          this.chartDataRsv = this.genarateGraphData(this.chartDataRsv, weeklyTotalArr);
          break;

        case "生産者当たりの生産効率の比較":
          // グラフデータ初期化
          this.chartDataRsv = this.initChartData(true);

          // 集計配列を生成して水揚げ日基準で集計
          weeklyTotalArr = this.calcTotal(61, 6, true);

          // 週別グラフデータを生成
          this.chartDataRsv = this.genarateGraphData(this.chartDataRsv, weeklyTotalArr, true);
          break;

        default:
          break;
      }
    },

    /**
     * 月別・週別切り替え時に重複チェックで使用しているフラグをリセットする
     */
    resetDuplicateFlag(summary_data) {

      summary_data.forEach((data) => {
        data.duplicate_flag = 0;
      });

      return summary_data;
    },

    /**
     * グラフ出力(月別)
     */
    monthlyOutput() {
      this.setDataMonth(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.uid,
        this.summary_data,
        (this.dispPagenationFlag = false)
      );
    },
    /**
     * グラフ出力(週別)
     */
    weeklyOutput() {
      this.setDataWeek(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.uid,
        this.summary_data,
        (this.dispPagenationFlag = true)
      );

      // 初期は現在月分を表示
      const now = new DateWrapper(Date.now()).format;
      const month_sub = Number(now.systemDate.substring(5, 7));
      // 現在月が7月～9月の場合は10月分を表示する
      if (7 <= month_sub && month_sub <= 9) {
        this.month = this.dispYear1.substring(0, 4) + "-10";
      //現在月が1月~6月の場合は表示年1に＋1する
      //令和4年度の場合 2022年10月~2023年6月がシーズンとなるため
      } else if (1 <= month_sub <= 6) {
        const year_sub = Number(this.dispYear1) + 1 ;
        this.month =
          year_sub + "-" + now.systemDate.substring(5, 7);
      //現在月が10月~12月の場合は表示年1の当月分を表示する
      } else {
        this.month =
          this.dispYear1.substring(0, 4) + "-" + now.systemDate.substring(5, 7);
      }
      this.$refs.month_picker_graph.updateSearchMonth(
        this.dispYear1.substring(0, 4),
        this.month
      );
    },
    /**
     * グラフ種類別キー設定
     */
    getTabItems() {
      let items = [];

      items.push({
        label: "月別",
        key: "1",
        callback: () => this.monthlyOutput(),
      });
      items.push({
        label: "週別",
        key: "2",
        callback: () => this.weeklyOutput(),
      });

      return items;
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },

    /**
     * グラフの設定を行う
     */
    setChartSettings() {
      // グラフの種類設定
      this.chartType = "LineChart";
      // グラフの横幅設定
      this.chartOptions.width = 420;
      // グラフの高さ設定
      this.chartOptions.height = 350;
      // グラフ表示枠の左端からの有効位置(px)と領域使用率
      this.chartOptions.chartArea = {
        left: 85,
        width: "100%",
      };
      // グラフ棒各幅設定
      this.chartOptions.bar = {
        groupWidth: "80%",
      };
      // 左右のY軸表示の設定
      this.chartOptions.series = {};
      this.chartOptions.vAxes = {};

      // Y軸の単位表示の設定
      this.chartOptions.vAxis = {
        title: "[1缶当たりの連数]",
        titleTextStyle: { italic: false },
      };

      // フォーカスターゲットをカテゴリに設定
      this.chartOptions.focusTarget = 'category';
    },

    /**
     * グラフデータの初期設定を行う
     */
    initChartData(byProducer = false) {

      var cnt;
      var month;
      var week;
      var chartData = [];

      // 凡例ラベル設定(R:令和)
      if (this.summary_data.length > 0) {
        var annotation1 = "R" + (this.dispYear1 - 2018);
        var annotation2 = "R" + (this.dispYear2 - 2018);
        var legendName = this.$parent.seaArea == "全海域" ? "県全体平均" : "海域平均";
      }

      if (this.tabIndex == 1) {   // 月別
        if (byProducer) { // 生産者別
          // 月別生産者別生産効率
          chartData = [
            [
              "時期",
              annotation1 + "自分",
              annotation2 + "自分",
              annotation1 + legendName,
            ],
            ["10月", 0, 0, 0],
            ["11月", 0, 0, 0],
            ["12月", 0, 0, 0],
            ["1月", 0, 0, 0],
            ["2月", 0, 0, 0],
            ["3月", 0, 0, 0],
            ["4月", 0, 0, 0],
            ["5月", 0, 0, 0],
            ["6月", 0, 0, 0],
          ];

        } else {  // 総生産効率
          // 月別総生産効率の比較
          chartData = [
            ["時期", annotation1 + legendName, annotation2 + legendName],
            ["10月", 0, 0],
            ["11月", 0, 0],
            ["12月", 0, 0],
            ["1月", 0, 0],
            ["2月", 0, 0],
            ["3月", 0, 0],
            ["4月", 0, 0],
            ["5月", 0, 0],
            ["6月", 0, 0],
          ];
        }

      } else {   // 週別
        if (byProducer) { // 生産者別
          // 週別生産者別生産効率

          // 情報設定(ヘッダ情報をセットする)
          chartData.push([
            "時期",
            annotation1 + "自分",
            annotation2 + "自分",
            annotation1 + legendName,
          ]);

          // 月週文字列, 当年自分, 比較年自分, 県全体初期化
          for (cnt = 0; cnt < 9; cnt++) {
            month = 10 + cnt;
            if (3 <= cnt) {
              month = cnt - 2;
            }

            for (week = 1; week <= 5; week++) {
              chartData.push([month.toString() + "月_" + week.toString() + "週", 0,0,0]);
            }
          }
        } else {  // 総生産効率

          // 週別総生産効率の比較
          // ヘッダ情報をセット
          chartData.push([
            "時期",
            annotation1 + legendName,
            annotation2 + legendName,
          ]);

          // 月週文字列, 当年県全体, 比較年県全体初期化
          for (cnt = 0; cnt < 9; cnt++) {
            month = 10 + cnt;
            if (3 <= cnt) {
              month = cnt - 2;
            }

            for (week = 1; week <= 5; week++) {
              chartData.push([month.toString() + "月_" + week.toString() + "週", 0,0]);
            }
          }
        }
      }

      return chartData;
    },

    /**
     * 集計配列を生成して水揚げ日基準で集計する
     * -月別・週別共通
     * -総生産効率・生産者別生産効率共通
     */
    calcTotal(rows, cols, byProducer = false) {

      // 集計用の配列を生成して0初期化
      // 総生産効率：[表示年1水揚げ, 表示年1出荷, 表示年2水揚げ, 表示年2出荷, 0, 0]
      // 生産者別：[表示年1水揚げ, 表示年1出荷, 表示年2水揚げ, 表示年2出荷, 県全体水揚げ, 県全体出荷]
      var totalArr = this.generate2DArray(rows, cols);

      // 水揚げデータ集計
      this.calcTotalCore(totalArr, byProducer);

      // 出荷データ集計
      this.calcTotalCore(totalArr, byProducer, true);

      return totalArr;
    },

    /**
     * 集計メイン
     * -月別・週別共通
     * -総生産効率・生産者別生産効率共通
     */
    calcTotalCore(totalArr, byProducer = false, isShipping = false) {
      var row = [];
      var month, week, index;
      var offset = isShipping == true ? 1 : 0;

      for (row of this.summary_data[0+offset]) {
        month = Number(row.month_week_num.substring(0, 2));
        week = Number(row.month_week_num.substring(2, 3));

        // index: 集計配列のインデックス
        if (this.tabIndex == 1) {   // 月別[1-12](0は未使用)
          index = month;
        } else if (this.tabIndex == 2) {   // 週別[1-60](0は未使用)
          index = (month - 1) * 5 + (week - 1) + 1;
        }

        if ((row.comparison_year == Number(this.dispYear1) && month >= 10) ||
           (row.comparison_year == Number(this.dispYear1) + 1) && month <= 6) {
          //表示年１の集計

          if (byProducer) {
            if (row.uid == this.uid) {
              totalArr[index][0+offset] = totalArr[index][0+offset] + row.total_amount;
            }
            totalArr[index][4+offset] = totalArr[index][4+offset] + row.total_amount;
          } else {
            totalArr[index][0+offset] = totalArr[index][0+offset] + row.total_amount;
          }

        } else if (row.comparison_year == Number(this.dispYear2) ||
                   row.comparison_year == Number(this.dispYear2) + 1) {
          //表示年２の集計

          if (byProducer) {
            if (row.uid == this.uid) {
              totalArr[index][2+offset] = totalArr[index][2+offset] + row.total_amount;
            }
          } else {
            totalArr[index][2+offset] = totalArr[index][2+offset] + row.total_amount;
          }
        }
      }
    },

    /**
     * 集計用配列をもとにグラフデータを生成する
     * -月別・週別共通
     * -総生産効率・生産者別生産効率共通
     */
    genarateGraphData(chartArr, totalArr, byProducer = false) {

      var index = 0;

      // 生産効率グラフデータ設定
      for (let i = 1; i < totalArr.length; i++) {
        index = this.getReplaceIndex(i);
        if (index == 0) continue;

        // 総生産効率グラフデータ
        // 生産者別生産効率グラフデータ
        // 1缶当たりの連数 = 水揚げtotal_amount / (出荷total_amount / 20)

        //表示年1
        if (totalArr[i][0] != 0 && totalArr[i][1] != 0) {
          chartArr[index][1] = Number(parseFloat(totalArr[i][0] / (totalArr[i][1] / 20)).toFixed(2));
        }

        //表示年2
        if (totalArr[i][2] != 0 && totalArr[i][3] != 0) {
          chartArr[index][2] = Number(parseFloat(totalArr[i][2] / (totalArr[i][3] / 20)).toFixed(2));
        }

        // 生産者別生産効率のみ
        if (byProducer) {
          //表示年1(県全体)用
          if (totalArr[i][4] != 0 && totalArr[i][5] != 0) {
            chartArr[index][3] = Number(parseFloat(totalArr[i][4] / (totalArr[i][5] / 20)).toFixed(2));
          }
        }
      }

      return chartArr;
    },

    /**
     * 与えられた集計データのインデックスをもとにグラフデータ用インデックスを返す
     * -月別・週別共通
     * -総生産効率・生産者別生産効率共通
     */
    getReplaceIndex(totalIndex) {

      var index = 0;

      if (this.tabIndex == 1) {
        if (totalIndex >= 1 && totalIndex <= 6) index = totalIndex + 3;
        if (totalIndex >= 7 && totalIndex <= 9) index = 0;
        if (totalIndex >= 10 && totalIndex <= 12) index = totalIndex - 9;
      } else if (this.tabIndex == 2) {
        if (totalIndex >= 1 && totalIndex <= 30) index = totalIndex + 15;
        if (totalIndex >= 31 && totalIndex <= 45) index = 0;
        if (totalIndex >= 46 && totalIndex <= 60) index = totalIndex - 45;
      }

      return index;
    },

    /**
     * 任意の行数×列数を任意の値(デフォルト0)で初期化する
     */
    generate2DArray(m, n, val = 0) {
      return Array.from(new Array(m),() => new Array(n).fill(val));
    },
  },
  computed: {
    tabItems() {
      return this.getTabItems();
    },
  },
};
</script>

<style scoped>
.tab-item {
  width: 150px;
}
.tab-active {
  color: white !important;
  background-color: primary !important;
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>

